export default "__VITE_ASSET__eCe9bGWr__"